export default __webpack_public_path__ + "static/media/humidity.07bf3723.svg";